var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"systemForm",attrs:{"id":"app"},on:{"scroll":function($event){return _vm.setScrollBar()}}},[_c('NavigateView',{staticClass:"nav"}),_c('router-view',{staticClass:"rv"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }